type JSONPrimitive = string | number | boolean | null
export type JSONValue = JSONPrimitive | JSONObject | JSONArray
export type JSONObject = {
    [key: string]: JSONValue
}
type JSONArray = Array<JSONValue>

export enum SchemaStringFormatType {
    Html = 'HTML',
    Json = 'JSON',
    Text = 'TEXT',
    Markdown = 'MARKDOWN',
}

type JSONSchemaCommonMetaData = {
    label: string | null
    description: string | null
    order: number | null
}

export type JSONSchemaMetaData =
    | {
          type: 'string'
          _meta: JSONSchemaCommonMetaData & {
              format: SchemaStringFormatType | null
          }
          children: null
      }
    | {
          type: 'number' | 'boolean'
          _meta: JSONSchemaCommonMetaData
          children: null
      }
    | {
          type: 'object'
          _meta: JSONSchemaCommonMetaData
          children: Record<string, JSONSchemaMetaData>
      }
    | {
          type: 'array'
          _meta: JSONSchemaCommonMetaData
          children: JSONSchemaMetaData | JSONSchemaMetaData[]
      }

export type ApiError = {
    code?: string | number
    message?: string
}

export type ErrorResponseDTO = {
    response?: {
        data?: {
            error?: {
                code?: string
                message?: string
            }
        }
        status?: number
    }
}
